import http from '../http-common';

class PagesData {
  getPage(slug) {
    return http.get(`/pages/${slug}`);
  }
}

export default new PagesData();
